import React from 'react'
import Portal from '../../../../component/portal'
import RenderItem from '../../../../component/item'
import { getProductListByType } from '../../../../component/service'
import { i18n } from '../../../../common/util'
import { AppContext } from '../../../../config/context'

class SectionList extends React.Component {
    constructor() {
        super(...arguments)
        const { labels } = window._inject_app_data_
        this.state = {
            labels,
            selectedLabels: labels.length ? [labels[0].id] : [],
            page: 1,
            pageSize: 10,
            list: [],
            hasMore: false
        }
    }

    componentDidMount() {
        const { selectedLabels, page } = this.state
        this.loadList(page, selectedLabels, true)
    }

    loadList = (page, labels, init = false) => {
        const ids = labels.join(',')
        if (!ids) {
            return this.setState({
                list: [],
                hasMore: false
            })
        }
        const { pageSize, list } = this.state
        getProductListByType('t', ids, page, pageSize).then(({ page: data }) => {
            const { records, total } = data
            const hasMore = total > page * pageSize
            this.setState({
                list: init ? records : list.concat(records),
                hasMore
            })
        })
    }

    toggleLabel = id => {
        const { selectedLabels } = this.state
        const actived = selectedLabels.includes(id)
        const newLabels = actived ? selectedLabels.filter(lid => lid !== id) : selectedLabels.concat(id)
        this.setState({
            page: 1,
            selectedLabels: newLabels
        })
        this.loadList(1, newLabels, true)
    }

    loadMore = () => {
        const page = this.state.page + 1
        const labels = this.state.selectedLabels
        this.setState({
            page
        })
        this.loadList(page, labels)
    }

    render() {
        const { list, hasMore, labels, selectedLabels } = this.state
        const { secName } = this.props
        const { lang } = this.context.user
        return <div>
            <h2 className="sec-page-title"><i className="icon cate"></i>{i18n(secName, lang)}</h2>
            <div className="section-labels-wrapper">
                <ul className="section-labels-ul">
                    {
                        labels.map(l => (<li className="section-label" key={l.id}>
                            <p title={i18n(l.name, lang)} className={selectedLabels.includes(l.id) ? 'label-content active' : 'label-content'} onClick={() => this.toggleLabel(l.id)}>
                                <i className="checkbox"></i>{i18n(l.name, lang)}
                            </p>
                        </li>))
                    }
                </ul>
            </div>
            <ul className="section-list-ul">
                {
                    list.map(item => RenderItem(item, lang))
                }
            </ul>
            {
                hasMore && <div className="section-list-more" onClick={this.loadMore}>查看更多</div>
            }
        </div>
    }
}

SectionList.contextType = AppContext
export default Portal(SectionList, 'sec-content-container')